import _ from 'lodash';
import feathers from '@feathersjs/client';
import localforage from 'localforage';

export default function createAuthenticationConfigurator( opts={} ) {

  return function configureAuthentication( app ) {

    app.configure( feathers.authentication( {
      header      : 'Authorization',
      prefix      : '',
      path        : '/api/authentication',
      jwtStrategy : 'jwt',
      entity      : 'member',
      service     : '/api/members',
      storageKey  : 'swiper-jwt',
      storage     : localforage,
    } ) );

  };
}
